import { PATH_PREFIX, TEAM_HEALTH_MONITOR_PAGE } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';

export const teamHealthMonitorEmbedRoute = createSiteRoute({
  exact: true,
  name: TEAM_HEALTH_MONITOR_PAGE,
  path: `${PATH_PREFIX.EMBEDS}/team-health/:teamId?/:teamHealthUuid?`,
});
